import { JSX } from 'react'
import { DefaultInputProps } from 'src/components/inputs/default-input/types'
import { cn } from 'src/helpers/cn'

const DefaultInput = ({
  label,
  className,
  rightIcon,
  leftIcon,
  labelClassName,
  error,
  required,
  ...props
}: DefaultInputProps): JSX.Element => {
  return (
    <div className="w-full flex flex-col gap-1">
      {label && (
        <span className="text-sm font-normal text-white pr-3">
          {label}
          {required && <span className="text-red-500"> *</span>}
        </span>
      )}

      <label
        className={cn(
          'relative w-full flex items-center rounded-xl border border-[#323233] p-3 focus-within:border-white transition-colors',
          error && 'border-red-500 focus-within:border-red-500',
          labelClassName,
        )}
      >
        {leftIcon && leftIcon}

        <input
          className={cn(
            'font-normal text-sm w-full placeholder:text-[#8d8d8d] text-[#ffffff] outline-none',
            className,
          )}
          {...props}
        />

        {rightIcon && rightIcon}

        {error && (
          <span className="absolute right-0 top-full mt-1 text-xs text-red-500">
            {error}
          </span>
        )}
      </label>
    </div>
  )
}

export default DefaultInput
